import React from 'react';
import _ from 'underscore';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { FilterEntity } from '@bingads-webui/filter-entity';
import { PredicateList } from '@bingads-webui/predicate-list-react';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { getStockPhotoFilterStyle } from '@bingads-webui-campaign/shared-image-experience-styles';

import { getShutterStockFilterSchema } from './shutter-stock-filter-schema';

const isPlainObject = value => _.isObject(value) && !_.isArray(value);

/* istanbul ignore next */
const queryToPredicates = (query) => {
  if (!isPlainObject(query) || _.isEmpty(query)) {
    return [];
  }
  if (query.$and) {
    return query.$and;
  }
  return [query];
};

/* istanbul ignore next */
const predicatesToQuery = (predicates) => {
  if (!_.isArray(predicates) || _.isEmpty(predicates)) {
    return {};
  }
  if (predicates.length === 1) {
    return predicates[0];
  }
  return {
    $and: predicates,
  };
};

class ShutterStockFilterInternal extends React.Component {
  constructor(props) {
    super(props);

    const { i18nLegacy } = props;

    this.filterSchema = getShutterStockFilterSchema(i18nLegacy);

    this.editableFilter = new FilterEntity({}, {
      entitySchema: this.filterSchema,
    });
  }

  onQueryChange = (query) => {
    const {
      data: prevData,
      setData,
    } = this.props;
    const currData = {
      predicates: queryToPredicates(query),
    };

    /* istanbul ignore else */
    if (!_.isEqual(prevData, currData)) {
      setData(currData);
    }
  }

  render() {
    const {
      classes,
      data: {
        predicates,
      },
      popoverContainer,
    } = this.props;

    const query = predicatesToQuery(predicates);
    this.editableFilter.updateQuery(query);

    return (
      <div className={`stock-photo-new-filter ${classes.filterContainer}`}>
        <I18nContext.Consumer>
          {i18n => (
            <PredicateList
              i18n={i18n}
              onApplySavedFilter={_.noop}
              onDeleteFilters={_.noop}
              selector={[]}
              entitySchema={this.filterSchema}
              editableFilter={this.editableFilter}
              selectableFilter={null}
              onEditableFilterUpdate={this.onQueryChange}
              onSelectableFilterUpdate={_.noop}
              disallowDuplicateFilters
              popoverContainer={popoverContainer}
            />
          )}
        </I18nContext.Consumer>
      </div>
    );
  }
}

ShutterStockFilterInternal.propTypes = {
  classes: PropTypes.objectOf(PropTypes.string).isRequired,
  setData: PropTypes.func.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
  i18nLegacy: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }),
  popoverContainer: PropTypes.shape(),
};

ShutterStockFilterInternal.defaultProps = {
  data: null,
  i18n: {
    getString: _.identity,
  },
  popoverContainer: {},
};

const ShutterStockFilter = withDefaultStyles(ShutterStockFilterInternal, getStockPhotoFilterStyle);
export { ShutterStockFilter };

